import React from 'react';
import { Candidate } from '../../../types';

interface CandidateDetailsTabProps {
  candidate: Candidate;
  getSourceColor: (source: string) => string;
}

const CandidateDetailsTab: React.FC<CandidateDetailsTabProps> = ({ candidate, getSourceColor }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <h4 className="text-lg font-medium text-gray-900 mb-4">Contact Information</h4>
          <dl className="space-y-3">
            <div>
              <dt className="text-sm font-medium text-gray-500">Email</dt>
              <dd className="text-sm text-gray-900">{candidate.email}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Phone</dt>
              <dd className="text-sm text-gray-900">{candidate.phone}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Nationality</dt>
              <dd className="text-sm text-gray-900">{candidate.nationality}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Date of Birth</dt>
              <dd className="text-sm text-gray-900">{new Date(candidate.dateOfBirth).toLocaleDateString()}</dd>
            </div>
          </dl>
        </div>

        <div>
          <h4 className="text-lg font-medium text-gray-900 mb-4">Application Info</h4>
          <dl className="space-y-3">
            <div>
              <dt className="text-sm font-medium text-gray-500">Source</dt>
              <dd>
                <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${getSourceColor(candidate.source)}`}>
                  {candidate.source === 'website' ? 'Website' : 
                   candidate.source === 'linkedin' ? 'LinkedIn' :
                   candidate.source === 'referral' ? 'Referral' :
                   candidate.source === 'job_board' ? 'Job Board' : candidate.source}
                </span>
              </dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Experience</dt>
              <dd className="text-sm text-gray-900">{candidate.experience} years</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Expected Salary</dt>
              <dd className="text-sm text-gray-900">${candidate.expectedSalary?.toLocaleString()}</dd>
            </div>
            <div>
              <dt className="text-sm font-medium text-gray-500">Available From</dt>
              <dd className="text-sm text-gray-900">
                {candidate.availableFrom ? new Date(candidate.availableFrom).toLocaleDateString() : 'Not specified'}
              </dd>
            </div>
          </dl>
        </div>
      </div>

      <div>
        <h4 className="text-lg font-medium text-gray-900 mb-4">Professional Background</h4>
        <dl className="space-y-4">
          <div>
            <dt className="text-sm font-medium text-gray-500">Education</dt>
            <dd className="text-sm text-gray-900">{candidate.education || 'Not specified'}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Previous Company</dt>
            <dd className="text-sm text-gray-900">{candidate.previousCompany || 'Not specified'}</dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Certificates</dt>
            <dd className="text-sm text-gray-900">
              <div className="flex flex-wrap gap-1 mt-1">
                {candidate.certificates?.map((cert, index) => (
                  <span key={index} className="inline-block bg-gray-100 text-gray-800 text-xs px-2 py-1 rounded">
                    {cert}
                  </span>
                )) || 'None specified'}
              </div>
            </dd>
          </div>
          <div>
            <dt className="text-sm font-medium text-gray-500">Languages</dt>
            <dd className="text-sm text-gray-900">
              <div className="flex flex-wrap gap-1 mt-1">
                {candidate.languages?.map((lang, index) => (
                  <span key={index} className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">
                    {lang}
                  </span>
                )) || 'None specified'}
              </div>
            </dd>
          </div>
        </dl>
      </div>

      {candidate.coverLetter && (
        <div>
          <h4 className="text-lg font-medium text-gray-900 mb-4">Cover Letter</h4>
          <div className="bg-gray-50 p-4 rounded-lg">
            <p className="text-sm text-gray-700 whitespace-pre-wrap">{candidate.coverLetter}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CandidateDetailsTab;
